import { render } from "./heading-wrapper.vue?vue&type=template&id=118612d8"
import script from "./heading-wrapper.vue?vue&type=script&lang=js"
export * from "./heading-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__